// Merkt sich, welche Umfrage gerade im Builder bearbeitet wird, damit der
// User nach dem ersten Erstellen weiterhin denselben Code editiert (PATCH)
// statt versehentlich eine zweite Umfrage anzulegen (POST).
//
// Wir speichern nur die Tokens — die Slots/Config liegen ohnehin im Store
// und werden beim PATCH mitgeschickt. localStorage, niemals an den Server.

const KEY = 'slot:current-build';

export type CurrentBuild = {
  id: string;
  adminToken: string;
  voterToken: string;
  /** Beim Erstellen abgespeicherter Voter-Count (für Lösch-Warnung). */
  voteCount?: number;
};

export function getCurrentBuild(): CurrentBuild | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CurrentBuild>;
    if (
      typeof parsed?.id !== 'string' ||
      typeof parsed?.adminToken !== 'string' ||
      typeof parsed?.voterToken !== 'string'
    ) {
      return null;
    }
    return {
      id: parsed.id,
      adminToken: parsed.adminToken,
      voterToken: parsed.voterToken,
      voteCount: typeof parsed.voteCount === 'number' ? parsed.voteCount : undefined,
    };
  } catch {
    return null;
  }
}

export function setCurrentBuild(build: CurrentBuild): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(build));
  } catch {
    // Quota exceeded oder Storage gesperrt — Edit-Workflow degradiert dann
    // auf „neue Umfrage", was schlechter ist als Crash.
  }
}

export function clearCurrentBuild(): void {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
